var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { normalizeObject, dataLayerPush } from "./utils";
// Pageview Event Handler
var pageViewEventHandler = function (e) {
    var pageData = {};
    e && e.detail
        && Object.assign(pageData, normalizeObject(e.detail));
    // Event specific overwrites 
    Object.assign(pageData, {
        "page_location": document.location.href,
        "page_path": document.location.pathname + document.location.search
    });
    dataLayerPush(pageData);
};
// Pageview Event Handler
var pageNotFoundEventHandler = function (e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var pageNotFoundData = normalizeObject(__assign(__assign({}, eventData), { error_message: "page_not_found", error_type: 404, event: "error_page_not_found", event_action: "error_page_not_found", event_category: "page_not_found", event_label: 404, non_interaction: true, page_errors: 1, total_errors: 1 }));
    dataLayerPush(pageNotFoundData);
};
var errorViewHandler = function (e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var _a = eventData.error_source_type, error_source_type = _a === void 0 ? "" : _a, _b = eventData.error_type, error_type = _b === void 0 ? "" : _b;
    var errorEventData = normalizeObject(__assign(__assign({}, eventData), { "event": "error_view", "event_action": "error_view", "event_label": error_source_type || error_type || "", "error_type": error_source_type || error_type || "", "event_errors": 1, "total_errors": 1, "non_interaction": true }));
    dataLayerPush(errorEventData);
};
// Login Event Handler
var loginEventHandler = function (e) {
    var loginEventData = e && e.detail
        && Object.assign({}, normalizeObject(e.detail));
    // Event specific overwrites 
    dataLayerPush(__assign(__assign({}, loginEventData), { event: "login_success", event_action: "login_success", event_category: "login", ret_login_success: 1, retain_interactions: 1, non_interaction: true }));
};
export { pageNotFoundEventHandler, pageViewEventHandler, loginEventHandler, errorViewHandler };
